/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react"
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'
import { onSnapshot, doc, collection, QuerySnapshot, DocumentData, limit, query, orderBy } from "firebase/firestore"
import { db } from "../../firebase"
import dayjs from "dayjs"
import _orderby from "lodash.orderby"

const RefrigerationTemperatures = () => {
  const [temperatures, setTemperatures] = useState<Array<any>>([])
  const devicesRef = collection(db, "devices")
  const refrigeratorRef = doc(devicesRef, "refrigerator")
  const refrigerationTemperaturesRef = query(collection(refrigeratorRef, "temperatures"), orderBy('date', 'desc'), limit(168))
  useEffect(() => {
    if (!refrigerationTemperaturesRef) return
    const unsubscribed = onSnapshot(refrigerationTemperaturesRef, ({ docs }: QuerySnapshot) => {
      const temperatures = docs.map((doc: DocumentData) => {
        const data = doc.data()
        return { datetime: data.date && dayjs(data.date.toDate()).format('YYYY-MM-DD HH:mm'), temperature: data.body.temperature }
      })
      const orderdTemperature = _orderby(temperatures, ['datetime', 'asc'])
      setTemperatures(orderdTemperature)
    })
    return unsubscribed
  }, [])

  return temperatures.length > 0 ? (
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          width={500}
          height={300}
          data={temperatures}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="datetime" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="temperature" stroke="#8884d8" />
        </LineChart>
      </ResponsiveContainer>

  ) : <div/>
}

export default RefrigerationTemperatures
